import Vue from 'vue';
import Vuex from 'vuex';
import user from "./user";
import application from "./application";
import instruments from "./instruments";
import queryMirrored from "./queryMirrored";
import timetable from "./timetable";
import staff from "./staff";
import exchange from "./exchange";
import cachedData from "./cachedData";
import settings from "./settings";
import forecast from "./forecast";
import reports from "./reports";
import loadTemplate from "./load-template";
Vue.use(Vuex);
/*
 * If not building with SSR mode, you can
 * directly export the Store instantiation
 */

export default function ()
/* { ssrContext } */
{
  var Store = new Vuex.Store({
    modules: {
      user: user,
      application: application,
      instruments: instruments,
      queryMirrored: queryMirrored,
      timetable: timetable,
      staff: staff,
      exchange: exchange,
      cachedData: cachedData,
      settings: settings,
      forecast: forecast,
      reports: reports,
      loadTemplate: loadTemplate
    },
    // enable strict mode (adds overhead!)
    // for dev mode only
    strict: process.env.DEV
  });
  return Store;
}
/**
 * @template T
 * @typedef {object} VuexStore
 * @property {T} state
 * @property {object} rootState
 * @property {(type: string, payload?: any, options?: object) => void} commit
 * @property {(type: string, payload?: any, options?: Object) => any|Promise<any>} dispatch
 * @property {Object<string, Function>} getters
 * @property {Object<string, Function>} rootGetters
 */